import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Attachment} from './attachment.model';
import {SubsidyType} from '../../models/subsidy-type.type';
import {AttachmentType} from './attachment-type.enum';

@Injectable({
	providedIn: 'root',
})
export class AttachmentsService {
	constructor(private http: HttpClient) {}

	checkFileName(file: File): string | null {
		const index = file.name.lastIndexOf('.');
		const name = file.name.substr(0, index || file.name.length);
		const regex = /[~'"#%&*:<>?/\\{|}.]/;
		const invalidCharacters = regex.test(name);
		const invalidLength = file.name.length > 50;

		if (invalidCharacters) {
			return 'Bestandsnaam mag volgende karakters niet bevatten: ~ \' " # % & * : < > ? / \\ { | } .';
		} else if (invalidLength) {
			return 'Bestandsnaam mag niet meer dan 50 karakters zijn.';
		}

		return null;
	}

	deleteAttachment(subsidyType: SubsidyType, subsidyId: number, attachmentId: number, forDossier: boolean = false): Observable<any> {
		const options = {
			body: {},
		};

		return this.http.request('delete', `/api12/${subsidyType}/subsidy${forDossier ? 'Dossier' : ''}/${subsidyId}/attachment/${attachmentId}`, options);
	}

	uploadAttachment(subsidyType: SubsidyType, subsidyId: number, file: File, type: AttachmentType | string, forDossier: boolean = false): Observable<Attachment> {
		const params: any = {
			fileName: file.name,
			documentType: type,
		};

		const formData = new FormData();
		formData.append('file', file, file.name);

		return this.http
			.post(`/api12/${subsidyType}/subsidy${forDossier ? 'Dossier' : ''}/${subsidyId}/attachment`, formData, {
				params,
			})
			.pipe(map((attachment) => new Attachment(attachment)));
	}
}
